import { useSearchParams } from "react-router";
import { useImportBankSelect } from "@features/bankSelect/components/BankSelect";
import { BankSelect } from "@features/bankSelect/components/BankSelect";
import { goToDashboard } from "@helpers/mainAppUrls";
import { useRoutes } from "../../hooks/useRoutes";

export const BankSelectWithRedirectPage = () => {
  const [searchParams] = useSearchParams();
  const { pushSelectBank } = useRoutes();

  const defaultSearchValue = (searchParams.get("q") as string) || "";

  const { banks, isFetching, searchValue, onChange, onSelect } =
    useImportBankSelect({
      defaultSearchValue,
      onSearchChange: pushSelectBank,
    });

  return (
    <BankSelect
      onSelect={onSelect}
      banks={banks}
      isFetching={isFetching}
      searchValue={searchValue}
      onChange={onChange}
      onClose={goToDashboard}
    />
  );
};
